import {
    Avatar,
    Box,
    ButtonGroup,
    Card,
    CardActions,
    CardContent,
    Grid,
    Stack,
    Tooltip,
    Typography,
    IconButton,
    Checkbox,
    Menu,
    MenuItem,
} from "@mui/material";
import MDButton from "components/MDButton";
import Search from "examples/Search";
import CommonLayout from "layouts/DashboardLayout";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { openSnackbar } from "../../redux/slices/common";
import {
    closeCustomModalDialog,
    openCustomModalDialog,
    setModalLoader,
} from "../../redux/slices/modalSlice";
import { deleteCategory, fetchCategoriesList } from "../../redux/slices/category";
import { useDebounce } from "hooks/useDebounce";
import EditIcon from "common/customIcons/edit";
import DeleteIcon from "common/customIcons/delete";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import StatusText from "common/component/StatusText";
import MDBox from "components/MDBox";
import NoDataFound from "common/component/NoDataFound";
import ManageCategories from "layouts/manageCategories";
import CommonLoading from "components/common/CommonLoading";
import { getData } from "utilities/common";
import { STILO } from "utilities/constants";
import CategoryTabs from "./categoryTabs";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import { AgGridTable } from "components/tables/AgGridTable";
import CategoryFilter from "./categoryFilter";
import { getPermissionsByMode } from "utilities/common";
import { hasSectionPermission } from "utilities/common";
import { HYPERWOLF } from "utilities/constants";
export default function SubCategoriesList() {
    // const [currentTab, setCurrentTab] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { categoriesList, loading = false } = useSelector((state) => state.category);
    const pageRef = useRef(0);
    const { search } = useLocation();
    const searchTermRef = useRef("");
    const [searchTerm, setSearchTerm] = useState("");
    const adminsMode = getData("adminsMode");
    const isStilo = JSON.parse(adminsMode) === STILO;
    const isHyperWolf = JSON.parse(adminsMode) === HYPERWOLF
    // const [categoryView, setCategoryView] = useState("grid");
    const mainGridApiRef = useRef("");
    const [searchParams, setSearchParams] = useSearchParams();
    const currentTab = searchParams?.get("filter");
    const categoryView = searchParams?.get("categoryView") || "grid";
    const productFiltersPayload = useRef({});
    const [isLoading, setIsLoading] = useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showBulkUpdate, setShowBulkUpdate] = useState(false);
    const isOpen = Boolean(anchorEl);
    const params = new URLSearchParams(window.location.search);

    const status = params.get("status") || "";
    const categoryIds = params.getAll("categoryIds") || "[]";
    const categoryTypes = params.getAll("categoryTypes") || "";
    const handleSearch = useDebounce(() => {
        pageRef.current = 0;
        searchFn();
    }, 500);

    let localUser = getData('login-user-info')
    if (localUser) {
        localUser = JSON.parse(localUser)
    }

    const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

    const canCreate = hasSectionPermission(permissionsForMode, "Manage Website", "Create");
    const canEdit = hasSectionPermission(permissionsForMode, "Manage Website", "Edit/Update");
    const canView = hasSectionPermission(permissionsForMode, "Manage Website", "View Only");
    const canDelete = hasSectionPermission(permissionsForMode, "Manage Website", "Delete");


    const deleteHandler = (categoryId) => {
        dispatch(setModalLoader(true));
        dispatch(deleteCategory(categoryId))
            .unwrap()
            .then((res) => {
                showError(res?.message, "success");
                dispatch(closeCustomModalDialog());
                pageRef.current = 0;
                const dataSource = { getRows };
                mainGridApiRef.current.ensureIndexVisible(0, null);
                mainGridApiRef.current.setGridOption("datasource", dataSource);
            })
            .catch((err) => {
                dispatch(setModalLoader(false));
                showError(err?.message, "error");
            });
    };


    const showError = (message, errortype) => {
        if (errortype === "success") {
            dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
        }
        if (errortype === "error") {
            dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
        }
    };

    const searchHandler = (event) => {
        const { value } = event.target;
        setSearchTerm(value);
        searchTermRef.current = value;
        handleSearch(value);
    };
    const searchFn = () => {
        const dataSource = { getRows };
        mainGridApiRef.current.ensureIndexVisible(0, null);
        mainGridApiRef.current.setGridOption("datasource", dataSource);

    };

    const onSelectionChanged = () => {
        const selectedRows = mainGridApiRef.current.getSelectedRows();
        if (selectedRows?.length > 0) {
            setShowBulkUpdate(true);
        } else {
            setShowBulkUpdate(false);
        }
    };

    function getSortInfo(data) {
        const sortInfo = {
            sortBy: '',
            direction: ''
        };
        data.forEach(item => {
            sortInfo.sortBy = item.colId;
            sortInfo.direction = item.sort === "asc" ? 'asc' : 'desc';
        });
        return sortInfo;
    }

    const getRows = useCallback(async (params) => {
        try {

            let filter = {};
            if (params?.sortModel.length) {
                filter = { ...getSortInfo(params?.sortModel) };
            }

            const result = await dispatch(
                fetchCategoriesList({
                    skip: pageRef.current,
                    limit: 20,
                    userType: "admin",
                    ...filter,
                    searchTerm: searchTermRef.current,
                    ...productFiltersPayload.current?.payload,
                    status: status || "",
                    // categoryId: categoryIdArray.join(","),
                    // categoryType: categoryTypes || "",
                })
            ).unwrap();

            const { categories = [], total = 0 } = result;
            params.successCallback(categories, total);
            pageRef.current = pageRef.current + 20;
        } catch (error) {
            params.successCallback([], 0);
        }
    },
        [productFiltersPayload.current]);



    useEffect(() => {
        // getRows();
        setSearchParams({
            filter: searchParams.get("filter") ? searchParams.get("filter") : "manage_categories",
            categoryView: searchParams.get("categoryView") ? searchParams.get("categoryView") : "grid",
            categoryIds: searchParams.get("categoryIds") ? searchParams.get("categoryIds") : "",
            categoryTypes: searchParams.get("categoryTypes") ? searchParams.get("categoryTypes") : "",
            status: searchParams.get("status") ? searchParams.get("status") : "",
        });
    }, []);



    // Updated column definitions to match your table structure
    const columnDefs = [
        {
            headerName: "Sub Category Name",
            field: "categoryName",
            //   checkboxSelection: true, // Optional: only if this should have row selection
            suppressMenu: true,
            sortable: true,
            minWidth: 240,
            flex: 1,
            wrapText: true,
            autoHeight: true,
            //   headerComponent: myComponent,
            cellStyle: { whiteSpace: "normal", lineHeight: "1.5" },
            cellRenderer: (props) => {
                if (!props?.data?._id) return "-";
                return (
                    <Stack direction="row" alignItems="center" gap={2}>
                        <Avatar
                            src={isHyperWolf ? props?.data?.categoryImage?.url ||  props?.data?.bannerImage?.url : props?.data?.categoryImage || props?.data?.bannerImage?.url}
                            sx={{ width: 40, height: 40 }}
                        >
                            {props?.value?.charAt(0)?.toUpperCase()}
                        </Avatar>
                        <Typography variant="body2" fontWeight={500}>
                            {props?.value || "-"}
                        </Typography>
                    </Stack>
                );
            },
        },
        {
            headerName: "Category Name",
            field: "webCategoryName",
            suppressMenu: false,
            sortable: true,
            minWidth: 180,
            flex: 1,
            cellRenderer: (props) => {
                return <Typography variant="body2">{props?.value || "-"}</Typography>;
            },
        },
        ...(!isStilo
            ? []
            : [
                {
                    headerName: "Category Type",
                    field: "categoryType",
                    suppressMenu: false,
                    sortable: false,
                    minWidth: 150,
                    flex: 1,
                    cellRenderer: (props) => {
                        return <Typography variant="body2">{props?.value || "-"}</Typography>;
                    },
                },
            ]),
        {
            headerName: "Status",
            field: "status",
            sortable: true,
            suppressMenu: false,
            cellRenderer: (props) => {
                if (!props?.data?._id) return "-";
                return <StatusText status={props?.data?.status} />;
            },
            flex: 1,
            minWidth: 100,
        },
        {
            headerName: "Actions",
            cellRenderer: (props) => {
                if (!props?.data?._id) return null;
                return (
                    <Box display="inline-flex" alignItems="center">
                        <IconButton
                            disabled={!canEdit}
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/categories/${props?.data?.categoryId || props?.data?._id}`);
                            }}
                            color="primary"
                            size="small"
                            variant="primary"
                        >
                            <EditIcon width="16px" height="16px" />
                        </IconButton>
                        {!isHyperWolf &&
                            <IconButton
                                disabled={!canDelete}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(
                                        openCustomModalDialog({
                                            modalData: {
                                                deleteHandler,
                                                deleteId: props.data?.categoryId || props.data?._id,
                                                deleteType: "category",
                                            },
                                            modal: "DELETE_MODAL",
                                        })
                                    );
                                }}
                                color="error"
                                size="small"
                                variant="primary"
                                sx={{ marginLeft: 1 }}
                            >
                                <DeleteIcon width="16px" height="16px" />
                            </IconButton>}
                    </Box>
                );
            },
            cellStyle: { textAlign: "right", justifyContent: "end" },
            headerClass: "right-aligned-cell-header",
            minWidth: 120,
            maxWidth: 120,
            flex: 1,
            pinned: "right",
        },
    ];

    const cannabinoidViewHandler = (viewType = "") => {
        setSearchParams({
            filter: searchParams.get("filter") ? searchParams.get("filter") : "manage_categories",
            categoryView: viewType,
        });
        pageRef.current = 0;
    };

    const applyCategoryFilter = (filterData) => {
        productFiltersPayload.current = filterData;
        pageRef.current = 0;

        const queryParams = {
            skip: 0,
            limit: 1000,
            userType: "admin",
            searchTerm: searchTermRef.current,
        };

        const bodyPayload = {
            categoryId: filterData?.payload?.categoryIds || "",
            categoryType: filterData?.payload?.categoryTypes || "",
            status: filterData?.queryPayload?.status || "",
        };

        const filters = {
            ...queryParams,
            ...bodyPayload,
        };

        if (categoryView === "list") {
            const dataSource = {
                getRows: (params) => {
                    const listQueryParams = {
                        ...filters,
                        skip: params.startRow,
                        limit: params.endRow - params.startRow,
                    };

                    dispatch(fetchCategoriesList(listQueryParams))
                        .unwrap()
                        .then((res) => {
                            const { categories = [], total = 0 } = res || {};
                            params.successCallback(categories, total);
                        })
                        .catch(() => {
                            params.successCallback([], 0);
                        });
                },
            };

            mainGridApiRef.current.ensureIndexVisible(0, null);
            mainGridApiRef.current.setGridOption("datasource", dataSource);
        } else {
            dispatch(fetchCategoriesList(queryParams));
        }
    };

    const getQueryValues = (data) => {
        productFiltersPayload.current = data;
        setIsLoading(false);
    };

    useEffect(() => {
        if (mainGridApiRef?.current) {
            if (loading) {
                mainGridApiRef.current.showLoadingOverlay();
            } else if (categoriesList?.total === 0) {
                mainGridApiRef.current.showNoRowsOverlay();
            } else {
                mainGridApiRef.current.hideOverlay();
            }
        }
    }, [categoriesList, loading]);

    return (
        <Box p={{ xs: 2, sm: 3, lg: 4 }}>
            <CategoryTabs />
            <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={3}>
                <Grid item xs={12} sm={4}>
                    <Stack direction="row" gap={1} alignItems="center">
                        <Typography variant="h4">Sub Categories</Typography>
                        <Stack direction="row" gap={1} className="grid-list-view" ml={2}>

                            <Tooltip title="Grid View">
                                <div className="gl-view">
                                    <GridViewIcon
                                        onClick={() => {
                                            setSearchParams({
                                                filter: searchParams?.get("filter"),
                                                categoryView: "grid",
                                            });

                                            setSearchTerm("");
                                            searchTermRef.current = "";
                                            cannabinoidViewHandler("grid");
                                        }}
                                        color={categoryView === "grid" ? "primary" : ""}
                                    />
                                </div>
                            </Tooltip>

                            <Tooltip title="list View">
                                <div className="gl-view">
                                    <ViewListIcon
                                        onClick={() => {
                                            setSearchTerm("");
                                            searchTermRef.current = "";
                                            cannabinoidViewHandler("list");
                                            setSearchParams({
                                                filter: searchParams?.get("filter"),
                                                categoryView: "list",
                                            });
                                        }}
                                        color={categoryView === "list" ? "primary" : ""}
                                    />
                                </div>
                            </Tooltip>
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Stack
                        direction="row"
                        justifyContent={{ xs: "start", sm: "end" }}
                        flexWrap="wrap"
                        alignItems="stretch"
                        gap={2}
                    >
                        <Search
                            placeholder="Search"
                            label=""
                            value={searchTerm}
                            onChange={searchHandler}
                        />
                        {
                            canCreate && !isHyperWolf &&
                            <MDButton
                                startIcon={<AddRoundedIcon fontSize="large" />}
                                variant="contained"
                                color="primary"
                                onClick={() => navigate("/categories/add")}
                            >
                                Add New Sub Category
                            </MDButton>
                        }

                    </Stack>
                </Grid>
            </Grid>

            <CategoryFilter
                applyCategoryFilter={applyCategoryFilter}
                getQueryValues={getQueryValues}
                setIsLoading={setIsLoading}
                productFiltersPayload={productFiltersPayload?.current}
            />
            {
                !isLoading &&
                <AgGridTable
                    col={columnDefs}
                    getRows={getRows}
                    mainGridApiRef={mainGridApiRef}
                    pageRef={pageRef}
                    isLoading={loading}
                    style={{ height: "70vh" }}
                    onSelectionChanged={onSelectionChanged}
                />
            }
        </Box>

    );
}
